import {
    SUPPORTER_PROJECT_REQUEST_DATA,
    SUPPORTER_PROJECT_RECEIVE_DATA,
    SUPPORTER_PROJECT_RECEIVE_NOT_FOUND,
    SUPPORTER_PROJECT_TOGGLE_BOOLEAN_VALUE,
    SUPPORTER_PROJECT_CHANGE_VALUE,
    SUPPORTER_PROJECT_SEND_SAVE,
    SUPPORTER_PROJECT_RECEIVE_SAVE,
    SUPPORTER_PROJECT_RECEIVE_SAVE_ERROR,
    SUPPORTER_PROJECT_EDIT, SUPPORTER_PROJECT_TOGGLE_ITEM_VALUE, SUPPORTER_PROJECT_SET_ITEM_VALUE
} from "../config/actions";

let defaultState = {
    id: null,
    projectId: null,
    state: null,
    period: null,
    queuePeriod: null,
    isFlexible: false,
    availableStates: null,
    availablePeriods: null,
    aborted: null,
    abortedReason: null,
    bestFriendsTicketAllowed: null,
    bestFriendsTicketAllowedChangeable: false,
    bestFriendsTicket: null,
    bestFriendsTicketToken: null,
    shiftsConfirmed: null,
    confirmShifts: null,
    ticketAllowed: null,
    ticket: null,
    supporterGroup: null,
    supporterGroupId: null,
    availableSupporterGroups: null,
    newGroupName: '',
    workTypes: [],
    workTypeIds: null,
    availableWorkTypes: null,
    checkOut: null,
    periodHasVariableFestivalWorkingDays: null,
    periodAllowedFestivalWorkingDays: null,
    festivalWorkingDays: null,
    availableAsSteward: null,
    stewardFormReceived: null,
    stewardNumber: null,
    copiedToSputnik: null,
    availableForBottleDeposit: null,
    edit: false,
    loading: false,
    notFound: false,
    items: [],
    availableBackstages: [],
    preferredBackstage: null,
    arrivalType: null,
    sleepingArrangement: null,
    sojusProjectCrew: null,
    externalCrewNeedsBackstage: false,
    externalCrewGotBackstage: null,
    carSticker: null,
    overrideArrivalType: null,
    overrideSleepingArrangement: null,
    overridePreferredBackstage: null,
};

const supporterProjectReducer = (state = defaultState, action) => {
    switch (action.type) {
        case(SUPPORTER_PROJECT_REQUEST_DATA):
            return Object.assign({}, state, defaultState);
        case(SUPPORTER_PROJECT_RECEIVE_DATA):
            return Object.assign({}, state, {
                id: action.data.id,
                projectId: action.data.projectId,
                state: action.data.state,
                period: action.data.period,
                queuePeriod: action.data.queuePeriod,
                isFlexible: action.data.isFlexible,
                availableStates: action.data.availableStates,
                availablePeriods: action.data.availablePeriods,
                aborted: action.data.aborted,
                abortedReason: action.data.abortedReason,
                bestFriendsTicketAllowed: action.data.bestFriendsTicketAllowed,
                bestFriendsTicketAllowedChangeable: action.data.bestFriendsTicketAllowedChangeable,
                bestFriendsTicket: action.data.bestFriendsTicket,
                bestFriendsTicketToken: action.data.bestFriendsTicketToken,
                shiftsConfirmed: action.data.shiftsConfirmed,
                confirmShifts: action.data.shiftsConfirmed !== undefined ? action.data.shiftsConfirmed.confirmed : false,
                ticketAllowed: action.data.ticketAllowed,
                ticket: action.data.ticket,
                supporterGroup: action.data.supporterGroup,
                supporterGroupId: action.data.supporterGroup ? action.data.supporterGroup.id : null,
                availableSupporterGroups: action.data.availableSupporterGroups,
                newGroupName: '',
                workTypes: action.data.workTypes,
                workTypeIds: action.data.workTypes ? action.data.workTypes.map((workType) => workType.id) : [],
                availableWorkTypes: action.data.availableWorkTypes,
                checkOut: action.data.checkOut,
                periodHasVariableFestivalWorkingDays: action.data.periodHasVariableFestivalWorkingDays,
                periodAllowedFestivalWorkingDays: action.data.periodAllowedFestivalWorkingDays,
                festivalWorkingDays: action.data.festivalWorkingDays ? action.data.festivalWorkingDays.toString() : null,
                availableAsSteward: action.data.availableAsSteward,
                stewardFormReceived: action.data.stewardFormReceived,
                stewardNumber: action.data.stewardNumber,
                copiedToSputnik: action.data.copiedToSputnik,
                availableForBottleDeposit: action.data.availableForBottleDeposit,
                daysOffPreset: action.data.daysOffPreset,
                extraWorkingDay: !!action.data.extraWorkingDay,
                askedForStewardAt: action.data.askedForStewardAt,
                items: action.data.items,
                availableBackstages: action.data.availableBackstages,
                preferredBackstage: action.data.preferredBackstage,
                arrivalType: action.data.arrivalType,
                sleepingArrangement: action.data.sleepingArrangement,
                sojusProjectCrew: action.data.sojusProjectCrew,
                externalCrewNeedsBackstage: action.data.externalCrewNeedsBackstage,
                externalCrewGotBackstage: action.data.externalCrewGotBackstage,
                carSticker: action.data.carSticker,
                overrideArrivalType: action.data.overrideArrivalType,
                overrideSleepingArrangement: action.data.overrideSleepingArrangement,
                overridePreferredBackstage: action.data.overridePreferredBackstage,
                notFound: false
            });
        case(SUPPORTER_PROJECT_RECEIVE_NOT_FOUND):
            return Object.assign({}, state, {
                id: null,
                projectId: null,
                state: null,
                period: null,
                queuePeriod: null,
                isFlexible: false,
                availableStates: null,
                availablePeriods: null,
                aborted: null,
                abortedReason: null,
                bestFriendsTicketAllowed: null,
                bestFriendsTicketAllowedChangeable: false,
                bestFriendsTicket: null,
                bestFriendsTicketToken: null,
                shiftsConfirmed: null,
                confirmShifts: null,
                ticketAllowed: null,
                ticket: null,
                supporterGroup: null,
                supporterGroupId: null,
                availableSupporterGroups: null,
                newGroupName: '',
                workTypes: [],
                workTypeIds: null,
                availableWorkTypes: null,
                checkOut: null,
                periodHasVariableFestivalWorkingDays: null,
                periodAllowedFestivalWorkingDays: null,
                festivalWorkingDays: null,
                availableAsSteward: null,
                stewardFormReceived: null,
                stewardNumber: null,
                copiedToSputnik: null,
                availableForBottleDeposit: null,
                items: [],
                edit: false,
                loading: false,
                availableBackstages: [],
                preferredBackstage: null,
                arrivalType: null,
                sleepingArrangement: null,
                sojusProjectCrew: null,
                notFound: true
            });
        case(SUPPORTER_PROJECT_TOGGLE_BOOLEAN_VALUE):
            return Object.assign({}, state, {
                [action.name]: !state[action.name]
            });
        case(SUPPORTER_PROJECT_TOGGLE_ITEM_VALUE):
            return {
                ...state,
                items: state.items.map((item) => {
                    if(item.key === action.key) {
                        return {
                            ...item,
                            value: !item.value
                        }
                    }
                    return item;
                })
            };
        case(SUPPORTER_PROJECT_SET_ITEM_VALUE):
            return {
                ...state,
                items: state.items.map((item) => {
                    if(item.key === action.key) {
                        return {
                            ...item,
                            value: action.value
                        }
                    }
                    return item;
                })
            };
        case(SUPPORTER_PROJECT_CHANGE_VALUE):
            return Object.assign({}, state, {
                [action.name]: action.value
            });
        case(SUPPORTER_PROJECT_EDIT):
            return Object.assign({}, state, {
                edit: true
            });
        case(SUPPORTER_PROJECT_SEND_SAVE):
            return Object.assign({}, state, {
                errors: false,
                loading: true
            });
        case(SUPPORTER_PROJECT_RECEIVE_SAVE):
            return Object.assign({}, state, {
                edit: false,
                loading: false
            });
        case(SUPPORTER_PROJECT_RECEIVE_SAVE_ERROR):
            return Object.assign({}, state, {
                edit: true,
                loading: false,
                errors: action.data.errors
            });
        default:
            return state;
    }
};

export default supporterProjectReducer;
